import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SentryService } from '../../services/sentry.service';

@Component({
  selector: 'app-sentry-error-tester',
  templateUrl: './sentry-error-tester.component.html',
  styleUrls: ['./sentry-error-tester.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SentryErrorTesterComponent implements OnInit {
  constructor(
    public modalCtrl: ModalController,
    public sentry: SentryService
  ) {}

  ngOnInit() {}
}
